<script>
    import FillInformationEvent from '@/online_booking/new/components/events/FillInformationEvent.vue';
    import ExpandableText from '@/system/components/global/ExpandableText';
    import ChooseEventUser from '@/online_booking/new/components/events/ChooseEventUser.vue';
    import ConfirmEvent from '@/online_booking/new/components/events/ConfirmEvent.vue';
    import EventPayment from '@/online_booking/new/components/events/EventPayment.vue';
    import EventSuccess from '@/online_booking/new/components/events/EventSuccess.vue';
    import Login from '@/online_booking/new/components/Login.vue';
    import LoginCode from '@/online_booking/new/components/LoginCode.vue';
    import ChooseLoginUser from '@/online_booking/new/components/ChooseLoginUser.vue';
    import ChooseLoginOrSignup from '@/online_booking/new/components/ChooseLoginOrSignup.vue';
    import SignUp from '@/online_booking/new/components/SignUp.vue';
    import OnlineBookingSidebarSteps from '@/online_booking/new/components/common/OnlineBookingSidebarSteps.vue';
    import SingleEvent from '@/online_booking/new/components/events/SingleEvent';
    import {http} from '@/system/http.js';
    import { mapActions, mapState } from 'vuex';
    import { bookingModules } from '@/online_booking/new/helpers/constants';

    export default {

        data: function () {

            return {
                loading: false,
                showEventConfirmation: false,
                event: null,
                event_group: null,
                events_overview_slug: events_overview_slug,
                requiredLogin: false,
                signUp: false,
                loginDesc: null,
                is_consent_enabled: false,
                is_waiting_list_enabled: false,
                consent_settings: null,
                loginSignupFlow: 'chooseLoginOrSignup',
                chooseFromLogin: true,
                settingsLogin: null,
                showCookieFixButton: false,
            }

        },

        props: ['slug'],

        mounted: function () {
            this.setCurrentModule(bookingModules.BOOK_EVENT);

            this.$event_bus.$on('infoEventAdded', (data) => {
                this.showEventConfirmation = true;
            });

            this.$event_bus.$on('LoadEventData', (data) => {
                this.user = data.user;
                this.settingsLogin = data.settings_login;

                if (this.settingsLogin && this.settingsLogin.allow_create == 0) {
                    this.loginSignupFlow = 'login'
                };
            });

            this.$event_bus.$on('goLogin', () => {
                this.loginSignupFlow = 'login';
            });

            this.$event_bus.$on('goSignUp', () => {
                this.loginSignupFlow = 'signUp';
            });

            this.$event_bus.$on('goLoginOrSignUp', () => {
                this.loginSignupFlow = (this.chooseFromLogin) ? 'login' : 'signUp';

            });

            this.$event_bus.$on('codeSent', (data) => {
                this.loginSignupFlow = 'loginCode';
                this.$event_bus.$emit('codeSent2', data);
            });

            this.$event_bus.$on('chooseLoginUser', (data) => {
                this.loginSignupFlow = 'chooseLoginUser';
                this.$event_bus.$emit('chooseLoginUser2', data);
            });

            this.$event_bus.$on('goBackToChoose', () => {
                this.loginSignupFlow = 'chooseLoginOrSignup';
            });

            this.$event_bus.$on('beforeCode', function(beforeCodeValue) {
            if (beforeCodeValue === 'login') {
                this.chooseFromLogin = true;
            } else {
                this.chooseFromLogin = false;
            }}.bind(this));

            this.init();
            this.scrollToTop();
        },

        components: {
            FillInformationEvent: FillInformationEvent,
            ChooseEventUser: ChooseEventUser,
            ConfirmEvent: ConfirmEvent,
            EventPayment: EventPayment,
            EventSuccess: EventSuccess,
            Login: Login,
            LoginCode: LoginCode,
            SignUp: SignUp,
            ChooseLoginUser: ChooseLoginUser,
            ChooseLoginOrSignup: ChooseLoginOrSignup,
            ExpandableText: ExpandableText,
            OnlineBookingSidebarSteps: OnlineBookingSidebarSteps,
            SingleEvent: SingleEvent,
        },

        methods: {
            ...mapActions('OnlineBooking', ['setCurrentModule', 'setCurrentStep']),

            init: function () {
                this.loading = true;


                http.get('/event/' + this.slug + "/get")
                    .then(({data}) => {
                        if (data.cookie_fix_required) {
                            this.fixCookie(data.online_booking_url, data.url, data.online_booking_url);
                            this.loading = false;
                            return;
                        }

                        if (data.required_login) {
                            this.requiredLogin = true;
                            this.loginDesc = data.settings_login.description_formatted;
                        } else {
                            this.requiredLogin = false;
                        }

                        this.is_consent_enabled = data.is_consent_enabled
                        this.is_waiting_list_enabled = data.is_waiting_list_enabled
                        this.consent_settings = data.consent_settings

                        this.event = data.event;
                        this.event_group = data.event_group;
                        this.$event_bus.$emit('LoadEventData', data);
                        this.loading = false;
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                    });
            },

            fixCookie(expectedUrl, popupUrl, redirect) {
                var expectedUrl = `${expectedUrl}?cookie_fixed=1`;

                window.AutomaticallyClosingPopupLink.configure('cookie-fix-button', expectedUrl, popupUrl, redirect);
                this.showCookieFixButton = true;
            },

            scrollToTop () {
                window.scrollTo(0, 0);
            }
        },

        computed: {
            ...mapState('OnlineBooking', ['currentStep']),

            eventName() {
                return this.event_group ? this.event_group.name : this.event.name;
            },

            eventIntervalFormatted() {
                return this.event_group ? this.event_group.interval_formatted : this.event.interval_formatted;
            },

            eventNotesFormatted() {
                return this.event_group ? this.event_group.description_formatted : this.event.notes_formatted;
            },

            isOpen() {
                return this.event_group ? this.event_group.is_open : (this.event ? this.event.is_open : false);
            },
        },

        watch: {
            '$route' (to, from) {
                // if the user hits the back button when the login component is active,
                // we need to show the events info component instead of the login component
                const redirect = from.query.redirect && from.query.redirect !== to.query.redirect;
                if (redirect && this.requiredLogin) {
                    this.setCurrentStep('eventInfo');
                }
            },

            currentStep () {
                this.scrollToTop();
            }
        },
    };

</script>


<template id="event-info">
    <div>
        <div class="text-center" v-if="loading">
            <div class="preloader"></div>
        </div>

        <div v-show="!loading">
            <div v-show="(requiredLogin && currentStep !== 'eventInfo') && !showCookieFixButton">
                <!-- Alert - Login required -->
                <div class="row">
                    <div class="col-md-12">
                        <ep-banner class="mb-6">
                            <i class="zmdi zmdi-info-outline m-r-10 alert-ico"></i>
                            <span>{{ trans('events.require_login_redirect') }}</span>
                        </ep-banner>
                    </div>
                </div>
                <!-- End of alert -->

                <!-- Alert - Login Description -->
                <div class="row" v-if="loginDesc">
                    <div class="col-md-12">
                        <div class="jumbotron-login m-b-20">
                            <span v-sanitize-html="loginDesc"></span>
                        </div>
                    </div>
                </div>
                <!-- End of alert -->
                <div class="row">
                    <div class="col-md-12">
                        <transition-group name="slideUp">
                            <choose-login-or-signup key="choose-login-or-signup" v-show="loginSignupFlow == 'chooseLoginOrSignup' && settingsLogin && settingsLogin.allow_create"></choose-login-or-signup>
                            <login key="login" v-show="loginSignupFlow == 'login'" class="row"></login>
                            <login-code key="login-code" v-show="loginSignupFlow == 'loginCode'" class="row"></login-code>
                            <choose-login-user :choose-from-login="chooseFromLogin" key="choose-login-user" v-show="loginSignupFlow == 'chooseLoginUser'" class="row"></choose-login-user>
                            <sign-up key="signup" v-show="loginSignupFlow == 'signUp'" class="row"></sign-up>
                        </transition-group>
                    </div>
                </div>
            </div>

            <div v-show="showCookieFixButton" class="text-center">
                <ep-banner class="m-t-30 m-b-30">{{ trans('online_booking.iframe_cookies_blocked') }}</ep-banner>

                <button id="cookie-fix-button" class="btn btn-custom">{{ trans('online_booking.iframe_cookies_blocked_cta') }}</button>

                <p class="m-t-30"><a href="" target="_blank">{{ trans('online_booking.iframe_cookies_blocked_second_cta') }}</a></p>
            </div>

            <div v-show="(!requiredLogin || currentStep === 'eventInfo') && !showCookieFixButton">
                <div class="row" v-show="isOpen && !showEventConfirmation">
                    <div class="col-md-4" v-if="!showEventConfirmation">
                        <online-booking-sidebar-steps
                            v-if="event_group !== null || event !== null"
                            :title="event_group ? trans('online_booking.events.title2') : trans('online_booking.events.title')"
                        />
                    </div>

                    <div class="col-md-8">
                        <div
                            class="panel-group"
                            id="event-accordion"
                            role="tablist"
                            aria-multiselectable="true"
                        >
                            <single-event
                                v-if="event || event_group"
                                :event="event_group ? event_group : event"
                                :is-event-group="!!event_group"
                                :required-login="requiredLogin"
                            />

                            <fill-information-event></fill-information-event>
                            <choose-event-user></choose-event-user>
                            <confirm-event></confirm-event>
                            <event-payment></event-payment>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <transition name="slideUpConfirm">
                            <event-success v-show="showEventConfirmation"></event-success>
                        </transition>
                        <!-- Event closed jumobtron -->
                        <div class="jumbotron jumbotron-new" v-if="!isOpen">
                            <h2>{{ trans('events.is_closed_public') }}</h2>
                            <p>{{ trans('calendar.closed') }}</p>
                            <router-link :to="'/overview/'+events_overview_slug" class="btn btn-custom">
                                <i class="zmdi zmdi-format-list-bulleted"></i>
                                <span class="m-l-10">{{ trans('events.goto_event_overview') }}</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
